/**
 * @generated SignedSource<<460c599037694fd14d389b534583c5cc>>
 * @relayHash 9203ca1c3f1dd776474f4a1b5b46683a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5a8f0bf7cefdeaf4f8d5660e4437c7f1202cb81fec69b986c0ee85314247d3d1

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type mainJiraSoftwareStartSprintPrototypeQuery$variables = {
  boardId: string;
  isCompanyManaged: boolean;
  sprintId: string;
};
export type mainJiraSoftwareStartSprintPrototypeQuery$data = {
  readonly boardScope: {
    readonly sprintWithStatistics: ReadonlyArray<{
      readonly defaultEndDate: AGG$DateTime | null | undefined;
      readonly defaultStartDate: AGG$DateTime | null | undefined;
      readonly goal: string | null | undefined;
      readonly name: string;
      readonly sprintMetadata: {
        readonly numCompletedIssues: number;
        readonly numOpenIssues: number;
        readonly unestimatedIssueCount?: number | null | undefined;
        readonly unestimatedIssueKeys?: ReadonlyArray<string | null | undefined> | null | undefined;
      };
      readonly " $fragmentSpreads": FragmentRefs<"startSprintPeriod_softwareStartSprintModalRelay">;
    } | null | undefined> | null | undefined;
  };
};
export type mainJiraSoftwareStartSprintPrototypeQuery = {
  response: mainJiraSoftwareStartSprintPrototypeQuery$data;
  variables: mainJiraSoftwareStartSprintPrototypeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCompanyManaged"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sprintId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardId"
  }
],
v4 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "sprintIds.0",
        "variableName": "sprintId"
      }
    ],
    "kind": "ListValue",
    "name": "sprintIds"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "goal"
},
v7 = {
  "kind": "ScalarField",
  "name": "defaultStartDate"
},
v8 = {
  "kind": "ScalarField",
  "name": "defaultEndDate"
},
v9 = {
  "kind": "ScalarField",
  "name": "numCompletedIssues"
},
v10 = {
  "kind": "ScalarField",
  "name": "numOpenIssues"
},
v11 = {
  "condition": "isCompanyManaged",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "unestimatedIssueKeys"
    },
    {
      "kind": "ScalarField",
      "name": "unestimatedIssueCount"
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainJiraSoftwareStartSprintPrototypeQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v3/*: any*/),
          "concreteType": "BoardScope",
          "kind": "LinkedField",
          "name": "boardScope",
          "plural": false,
          "selections": [
            {
              "args": (v4/*: any*/),
              "concreteType": "SprintWithStatistics",
              "kind": "LinkedField",
              "name": "sprintWithStatistics",
              "plural": true,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": (v5/*: any*/),
                  "action": "THROW",
                  "path": "boardScope.sprintWithStatistics.name"
                },
                (v6/*: any*/),
                (v7/*: any*/),
                (v8/*: any*/),
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "SoftwareSprintMetadata",
                    "kind": "LinkedField",
                    "name": "sprintMetadata",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "RequiredField",
                        "field": (v9/*: any*/),
                        "action": "THROW",
                        "path": "boardScope.sprintWithStatistics.sprintMetadata.numCompletedIssues"
                      },
                      {
                        "kind": "RequiredField",
                        "field": (v10/*: any*/),
                        "action": "THROW",
                        "path": "boardScope.sprintWithStatistics.sprintMetadata.numOpenIssues"
                      },
                      (v11/*: any*/)
                    ]
                  },
                  "action": "THROW",
                  "path": "boardScope.sprintWithStatistics.sprintMetadata"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "startSprintPeriod_softwareStartSprintModalRelay"
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "boardScope"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainJiraSoftwareStartSprintPrototypeQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "BoardScope",
        "kind": "LinkedField",
        "name": "boardScope",
        "plural": false,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "SprintWithStatistics",
            "kind": "LinkedField",
            "name": "sprintWithStatistics",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "concreteType": "SoftwareSprintMetadata",
                "kind": "LinkedField",
                "name": "sprintMetadata",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ]
              },
              (v12/*: any*/)
            ]
          },
          (v12/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "5a8f0bf7cefdeaf4f8d5660e4437c7f1202cb81fec69b986c0ee85314247d3d1",
    "metadata": {},
    "name": "mainJiraSoftwareStartSprintPrototypeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9ff5d851732ba2b395256eb73ffe6c21";

export default node;
